<template>
    <div>
        <v-row>
            <v-col cols="5">
                <v-boilerplate type="card-heading" min-width="100%" max-height="40px"></v-boilerplate>
                <v-boilerplate type="card-heading" max-height="40px"></v-boilerplate>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5">
                <v-boilerplate type="image"></v-boilerplate>
            </v-col>
            <v-col cols="6">
                <v-boilerplate type="text" class="py-1"></v-boilerplate>
                <v-boilerplate type="text" class="py-1"></v-boilerplate>
                <v-boilerplate type="text" class="py-1"></v-boilerplate>
                <v-divider></v-divider>
                <v-boilerplate type="text" class="py-1"></v-boilerplate>
                <v-boilerplate type="text" class="py-1"></v-boilerplate>
                <v-boilerplate type="button" class="py-1" min-width="300px"></v-boilerplate>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "ProductCardSkeleton",
        components:{
            VBoilerplate: {
                functional: true,

                render (h, { data, props, children }) {
                    return h('v-skeleton-loader', {
                        ...data,
                        props: {
                            boilerplate: true,
                            elevation: 0,
                            ...props,
                        },
                    }, children)
                },
            }
        }
    }
</script>

<style scoped>

</style>
